import { _ } from 'numeral';
import useGraphQLClient from './graphqlClient';
import {
  SortOrder,
  PopularProductions,
  PopularProductionsOrderByWithRelationInput,
  PopularProductionsWhereInput,
} from './spotwrite';

/**
 * 作品の検索条件
 */
export type PopularPuroductionsSearchCondition = {
  genreId?: number;
  formId?: number;
  limit?: number;
  offset?: number;
  orderBy?: PopularProductionsOrderByWithRelationInput[];
};

class PopularProductionService {
  client = useGraphQLClient();

  /**
   * 検索条件を整形します
   * @param condition
   * @returns
   */
  private buildSearchWhere = (condition: PopularPuroductionsSearchCondition) => {
    const andWhere: PopularProductionsWhereInput[] = [];

    if (condition.genreId) {
      andWhere.push({
        production: {
          is: { productionGenres: { some: { genreId: { equals: condition.genreId } } } },
        },
      });
    }
    if (condition.formId) {
      andWhere.push({
        production: { is: { formId: { equals: condition.formId } } },
      });
    }

    return {
      AND: andWhere,
    };
  }

  /**
   * 人気の作品を検索
   * @param where
   */
  public async search(condition: PopularPuroductionsSearchCondition) {
    // 検索条件ビルド
    const where = this.buildSearchWhere(condition);
    try {
      const res = await this.client.findManyPopularProductions({
        where,
        take: condition.limit,
        skip: condition.offset,
        orderBy: {
          displayOrder: SortOrder.Asc,
        },
      });
      return res.findManyPopularProductions as PopularProductions[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * 人気の作品を取得
   * @param limit
   */
  public popular = async (limit: number) => {
    const condition: PopularPuroductionsSearchCondition = {
      limit: limit > 0 ? limit : 10,
    };
    return this.search(condition);
  }
}
export default new PopularProductionService();
